import React from "react";
import { useLang } from "@/lib/i18n";
import { Languages } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
  const { toggle, lang } = useLang();
  return (
    <button
      onClick={toggle}
      data-testid="language-toggle"
      aria-label="Toggle language English / Odia"
      className={`inline-flex items-center gap-2 min-h-[44px] px-3 rounded-full bg-thali-turmeric/90 text-thali-ink font-heading font-bold border border-thali-turmericdark/30 hover:bg-thali-turmeric transition-colors ${className}`}
    >
      <Languages className="w-4 h-4" />
      <span className={lang === "en" ? "od" : ""}>{lang === "en" ? "ଓଡ଼ିଆ" : "English"}</span>
    </button>
  );
}
